var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticStyle:{"height":"50px"}},[_c('button',{attrs:{"value":"1"},on:{"click":function($event){return _vm.move(1)}}},[_vm._v("1")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }